import type { LazyQueryExecFunction, OperationVariables } from "@apollo/client";
import { useLazyQuery } from "@apollo/client";

import { GET_GIT_ROOT_MANAGEMENT_DETAILS } from "../../queries";
import type { IGitRootManagementDetailsAttr } from "../../types";
import { Logger } from "utils/logger";

type TQueryRequest = LazyQueryExecFunction<
  { root: IGitRootManagementDetailsAttr },
  OperationVariables
>;

const useGitRootDetailsQuery = (): { requestRootInfo: TQueryRequest } => {
  const [requestRootInfo] = useLazyQuery<{
    root: IGitRootManagementDetailsAttr;
  }>(GET_GIT_ROOT_MANAGEMENT_DETAILS, {
    onError: ({ graphQLErrors }): void => {
      graphQLErrors.forEach((error): void => {
        Logger.error("Couldn't load root management details", error);
      });
    },
  });

  return { requestRootInfo };
};

export { useGitRootDetailsQuery };
